module.exports = __webpack_public_path__ + "static/media/error500.394c5e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/img/error/error500.png
// module id = 702
// module chunks = 8